export function parseJwtClaims<T>(token: string): T {
  const payload = token.split('.')[1];

  const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
  const binary = atob(base64);
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));

  return JSON.parse(new TextDecoder().decode(bytes));
}
